import { render, staticRenderFns } from "./jiuyetongji.vue?vue&type=template&id=2b0a4228&scoped=true"
import script from "./jiuyetongji.vue?vue&type=script&lang=js"
export * from "./jiuyetongji.vue?vue&type=script&lang=js"
import style0 from "./jiuyetongji.vue?vue&type=style&index=0&id=2b0a4228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a4228",
  null
  
)

export default component.exports